import { setTheme } from "theme/default/setTheme";

export const color_rgba_34_36_38_15 = setTheme(({ theme }) => theme.colors.color_rgba_34_36_38_15);
